module.exports = __webpack_public_path__ + "img/reward.9f227f24.svg";